import { CASES } from './constants';

const initialState = {
    templates: [],
    filterForm: {},
    uploadForm: {
        action: '',
        entityType: '',
        template: '',
        dateFormat: '',
        includeAllFields: true,
    },
    actionOptions: [],
    dateFormatOptions: [],
    entityTypeOptions: [],
    templateOptions: [],
    fieldTypes: [],
    customFields: [],
    fieldGroups: [],
    checkedState: {},
    isDrawerOpen: false,
    customFieldList: [],
    selectedCustomList: '',
    isSavedTemplatesOpen: false,
};

export function templates(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_TEMPLATES: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_TEMPLATES_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_TEMPLATES: {
            return initialState;
        }
        default:
            return state;
    }
}
